// extracted by mini-css-extract-plugin
export default {"header_button":"entity-header_header_button__x26Cw","logo":"entity-header_logo__Vdf4w","competition":"entity-header_competition__bh0J8","subtitle":"entity-header_subtitle__ZsU7T"};